module.exports = __webpack_public_path__ + "fonts/lato-bold.6506895a.woff2";